import "./src/assets/css/global.css"; // Adjust the path according to where your file is located
import React from "react"
import { AudioPlaybackProvider } from "./src/context/AudioPlaybackContext"

export const wrapRootElement = ({ element }) => (
  <AudioPlaybackProvider>{element}</AudioPlaybackProvider>
)

export const shouldUpdateScroll = ({ routerProps }) => {
  const disableScrollUpdate =
    routerProps?.location?.state?.disableScrollUpdate ?? false

  if (disableScrollUpdate) {
    return false
  }

  // Tell Gatsby to move to the top on each route change.
  return [0, 0]
}
